export default class TemplateSelector {
    constructor(container, templates) {
        this.container = container;
        this.templates = templates;
        this.isVisible = true;
        this.selectedTemplate = null;
        
        this.render();
        this.bindEvents();
    }

    render() {
        // Create template grid container
        this.element = document.createElement('div');
        this.element.className = 'stc-template-grid';
        
        const gridHtml = `
            <div class="stc-modal-header">
                <h2 class="stc-modal-title">Select Your Design</h2>
            </div>
            <div class="stc-template-grid-content">
                ${this.templates.map(template => `
                    <div class="stc-template-item" data-template-id="${template.id}">
                        <div class="stc-template-preview">
                            ${template.thumbnail ? 
                                `<img src="${template.thumbnail}" alt="${template.title}">` :
                                '<div class="stc-template-placeholder">No Preview</div>'
                            }
                        </div>
                        <div class="stc-template-info">
                            <div class="stc-template-title">${template.title}</div>
                            <button class="stc-template-select">Select Design</button>
                        </div>
                    </div>
                `).join('')}
            </div>
        `;

        this.element.innerHTML = gridHtml;
        this.container.appendChild(this.element);
    }

    bindEvents() {
        this.element.addEventListener('click', (e) => {
            const selectBtn = e.target.closest('.stc-template-select');
            if (selectBtn) {
                const templateItem = selectBtn.closest('.stc-template-item');
                const templateId = templateItem.dataset.templateId;
                this.selectTemplate(templateId);
            }
        });
    }

    async selectTemplate(templateId) {
        try {
            // Find template data
            const template = this.templates.find(t => t.id === templateId);
            if (!template) throw new Error('Template not found');

            console.log('🎯 [_stc_edit] Selecting template:', templateId, 'for product:', window.octStcCustomizer?.product_id);

            // Load template data from server
            const response = await fetch('/wp-admin/admin-ajax.php', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
                body: new URLSearchParams({
                    action: 'load_template',
                    template_id: templateId,
                    product_id: window.octStcCustomizer?.product_id || '',
                    nonce: window.octStcCustomizer?.nonce || ''
                })
            });

            if (!response.ok) throw new Error('Failed to load template');

            const data = await response.json();
            if (!data.success) throw new Error(data.data || 'Failed to load template');

            console.log('🎯 [_stc_edit] Template data received:', data.data.has_existing_data ? 'WITH existing data' : 'WITHOUT existing data');

            // Parse and display the template config
            try {
                const templateConfig = JSON.parse(data.data.config);
                console.log('🎯 [_stc_edit] Parsed _stc_template_state:', templateConfig);
            } catch (e) {
                console.log('🎯 [_stc_edit] Could not parse template config:', data.data.config);
            }

            this.selectedTemplate = {
                ...template,
                ...data.data
            };

            // Hide template grid
            this.hide();

            // Emit template selected event
            const event = new CustomEvent('stc:template:selected', {
                detail: { template: this.selectedTemplate }
            });
            this.container.dispatchEvent(event);

        } catch (error) {
            console.error('Error selecting template:', error);
            // Show error to user
            alert('Failed to load template. Please try again.');
        }
    }

    show() {
        this.isVisible = true;
        this.element.style.display = '';
    }

    hide() {
        this.isVisible = false;
        this.element.style.display = 'none';
    }

    destroy() {
        this.element.remove();
    }
}